import React from 'react';
import { CheckPicker } from 'rsuite';

export function FiltroTreinamentos(props) {
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <CheckPicker {...props} placeholder="Treinamentos" />;
}
